// mascot.ts — Endpoints mascotte « Professeur Ornaxion ».
// GET ouverts (référentiel) ; écriture gardée par mascot.write côté back.
import { req } from './_internals.js';

export const mascotApi = {
  getMascotSettings: () => req('GET', '/mascot/settings'),
  updateMascotSettings: (d: unknown) => req('PUT', '/mascot/settings', d),
  getMascotTriggerCases: () => req('GET', '/mascot/trigger-cases'),
  getMascotPhrases: (trigger_case?: string) =>
    req(
      'GET',
      '/mascot/phrases' + (trigger_case ? '?case=' + encodeURIComponent(trigger_case) : ''),
    ),
  createMascotPhrase: (d: unknown) => req('POST', '/mascot/phrases', d),
  updateMascotPhrase: (id: number | string, d: unknown) => req('PUT', '/mascot/phrases/' + id, d),
  deleteMascotPhrase: (id: number | string) => req('DELETE', '/mascot/phrases/' + id),
};
